// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__1B7ot","btn":"styles_btn__99vI8","icon":"styles_icon__BvsC_"};